var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('SectionHero',{attrs:{"variant":_vm.hero.variant}},[_c('OrganismHero',{attrs:{"hero":_vm.hero}})],1),_vm._v(" "),_c('client-only',[_c('SectionDefault',[_c('Builder',{attrs:{"blocks":_vm.blocks}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }